import { render, staticRenderFns } from "./HanhChinh.vue?vue&type=template&id=23308614"
import script from "./HanhChinh.vue?vue&type=script&lang=js"
export * from "./HanhChinh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports